import { render, staticRenderFns } from "./IndustrySolution.vue?vue&type=template&id=e61f3986&scoped=true"
import script from "./IndustrySolution.vue?vue&type=script&lang=js"
export * from "./IndustrySolution.vue?vue&type=script&lang=js"
import style0 from "./IndustrySolution.vue?vue&type=style&index=0&id=e61f3986&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61f3986",
  null
  
)

export default component.exports